import React from "react";
import MemberSidebar from "./MemberSidebar";

// The content frame of every Co-Work page below the banner. Signed-in buyers and sellers get their
// profile sidebar on the left; visitors (and admins, who have no marketplace profile) get the content
// full width.
export default function MemberShell({ user, onSignOut, children }) {
  const isMember = !!(user && user.role);
  return (
    <div className={`max-w-7xl mx-auto px-6 md:px-12 ${isMember ? "grid lg:grid-cols-[290px_minmax(0,1fr)] gap-8 items-start" : ""}`}>
      {isMember && <MemberSidebar user={user} onSignOut={onSignOut} />}
      <div className="min-w-0">{children}</div>
    </div>
  );
}
